module.exports = new __parcel__URL__("invigorate.cf9a3fb2.png").toString();